import React from 'react';

const ErrorState = ({ error }) => {
  return (
    <section id="services" className="services-section py-1" style={{ backgroundColor: `var(--color-bodyBlack)`}}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="display-4 fw-bold mb-4 service-title" style={{ color: `var(--color-white)` }}>
              Our Core Services
            </h2>
            <p className="lead subtitle" style={{ color: `var(--color-white)`, maxWidth: '800px', margin: '0 auto' }}>
              Empowering your business with cutting-edge technology solutions and expert guidance
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="error-message">
              <h4>Unable to load services</h4>
              <p>Error: {error}</p>
              <button 
                className="btn text-white mt-3"
                style={{
                  backgroundColor: `var(--color-primary)`,
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 20px'
                }}
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ErrorState;